import { render } from "./HeroiconsOutlineDotsHorizontal.vue?vue&type=template&id=861e781a"
const script = {}

import exportComponent from "/home/omid_es327/Projects/mohovers/dev/dev-laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineDotsHorizontal.vue"]])

export default __exports__